var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('Navbar'),_c('div',{staticClass:"colmn"},[_c('SideMenu'),_c('div',{staticClass:"home-main-wrapper"},[_c('div',{staticClass:"main"},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }